<template>
    <div class="border-0 flex flex-col items-center" v-bind:class="$attrs.class">
        <input-label>Код 2FA</input-label>
        <input
            ref="input"
            class="w-32 mx-auto border border-gray-300 shadow-sm text-2xl text-center rounded
             focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
            v-bind="inputAttrs"
            v-model="modelValue"
            type="text"
        >
        <input-error :message="error"/>
    </div>
</template>

<script>
import InputLabel from "@/Components/Label";
import InputError from "@/Components/InputError";

export default {
    inheritAttrs: false,
    components: {
        InputLabel,
        InputError,
    },
    props: {
        modelValue: String|Number,
        error: String,
    },
    computed: {
        inputAttrs() {
            const { _, ...attrs } = this.$attrs;
            delete attrs.class;
            return attrs;
        },
    },
}
</script>
